import { render, staticRenderFns } from "./_OrganStepper.vue?vue&type=template&id=34f078bc&scoped=true"
import script from "./_OrganStepper.vue?vue&type=script&lang=js"
export * from "./_OrganStepper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f078bc",
  null
  
)

export default component.exports